// Servicio para el Upload de ficheros tipo fotos ó pdf's
// tipo: 'users' | 'articulos' | 'clientes' | 'albaranEntrada' | 'docCliente')

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IApiResp } from '../interfaces/api-resp';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
  apiURL: string = environment.apiURL;
  private endPoint: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  async uploadFoto(id: string, archivo: File, tipo: 'users' | 'articulos' | 'clientes' | 'albaranEntrada' | 'docCliente') {

    if (tipo === 'users' || tipo === 'articulos' || tipo === 'clientes') this.endPoint = 'imgUpload';
    if (tipo === 'albaranEntrada' || tipo === 'docCliente') this.endPoint = 'pdfUpload';

    try {
      const path = `${this.apiURL}/${this.endPoint}`;
      const formData = new FormData();
      formData.append('id', id);
      formData.append('tipo', tipo);
      formData.append('archivo', archivo);

      const resp = await fetch(path, {
        method: 'post',
        body: formData
      });

      const respAwa = await resp.json();
      return respAwa;

    } catch (error) {
      console.log('error en upload-file.service', error)
      return (false);
    }
  }

  imgDelete(tipo: 'users' | 'articulos' | 'clientes' | 'albaranEntrada' | 'docCliente', id: string) {
    const path = `${this.apiURL}/imgDelete/${tipo}/${id}`;
    return this.http.get<IApiResp>(path)
      .pipe(
        catchError(error => {
          return throwError(() => new Error(error));
        })
      )
  }


}
